import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.health;

const healthData = createSelector([selector], (state) => state);

export default {
  healthData
};
